import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function TermsOfService() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="page-content">
            <Container>
                <Row>
                    <Col lg={8} className="mx-auto">
                        <div className="page-header text-center mb-5">
                            <h1 className="page-title gradient-text">Termini di Servizio</h1>
                            <p className="page-subtitle">
                                Condizioni generali di utilizzo del sito e dei servizi
                            </p>
                        </div>

                        <Card className="content-card">
                            <Card.Body>
                                <h2>1. Informazioni Generali</h2>
                                <p>
                                    Il presente documento disciplina l'utilizzo del sito web bearsoftware.it 
                                    e dei servizi offerti da BearSoftware di Carlo Zamponi, P.IVA IT03341180135.
                                </p>

                                <h2>2. Accettazione dei Termini</h2>
                                <p>
                                    L'utilizzo del sito web e dei servizi implica l'accettazione incondizionata 
                                    dei presenti termini di servizio. Se non si accettano questi termini, 
                                    si prega di non utilizzare il sito.
                                </p>

                                <h2>3. Descrizione dei Servizi</h2>
                                <p>BearSoftware offre i seguenti servizi professionali:</p>
                                <ul>
                                    <li>Sviluppo software e applicazioni web</li>
                                    <li>Sviluppo applicazioni mobile (Flutter, Android nativo)</li>
                                    <li>Sviluppo e-commerce (Magento, WooCommerce)</li>
                                    <li>Servizi Odoo ERP (sviluppo, personalizzazione, gestione)</li>
                                    <li>Servizi cloud e infrastruttura IT</li>
                                    <li>Consulenza tecnica e assistenza</li>
                                    <li>Amministrazione server (Linux, Windows)</li>
                                </ul>

                                <h2>4. Utilizzo del Sito</h2>
                                <p>L'utente si impegna a:</p>
                                <ul>
                                    <li>Utilizzare il sito in modo lecito e conforme alle leggi vigenti</li>
                                    <li>Non compromettere la sicurezza o il funzionamento del sito</li>
                                    <li>Non utilizzare il sito per scopi illeciti o dannosi</li>
                                    <li>Rispettare i diritti di proprietà intellettuale</li>
                                </ul>

                                <h2>5. Contratti di Servizio</h2>
                                <p>
                                    I servizi professionali sono regolati da contratti specifici che definiscono:
                                </p>
                                <ul>
                                    <li>Ambito del lavoro e deliverable</li>
                                    <li>Tempi di consegna e milestone</li>
                                    <li>Costi e modalità di pagamento</li>
                                    <li>Responsabilità delle parti</li>
                                    <li>Condizioni di garanzia e supporto</li>
                                </ul>

                                <h2>6. Pagamenti</h2>
                                <p>
                                    I pagamenti sono regolati secondo quanto stabilito nei singoli contratti. 
                                    Generalmente prevedono:
                                </p>
                                <ul>
                                    <li>Acconto del 50% all'avvio del progetto</li>
                                    <li>Saldo alla consegna o secondo milestone concordate</li>
                                    <li>Fatturazione secondo normativa italiana vigente</li>
                                    <li>Termini di pagamento: 30 giorni data fattura</li>
                                </ul>

                                <h2>7. Proprietà Intellettuale</h2>
                                <p>
                                    Tutti i contenuti del sito (testi, immagini, loghi, design) sono 
                                    di proprietà di BearSoftware o utilizzati con licenza. È vietata 
                                    la riproduzione senza autorizzazione scritta.
                                </p>

                                <h2>8. Responsabilità e Garanzie</h2>
                                <p>
                                    BearSoftware si impegna a fornire servizi professionali secondo 
                                    le migliori pratiche del settore. La responsabilità è limitata 
                                    al valore del contratto specifico.
                                </p>

                                <h2>9. Supporto e Assistenza</h2>
                                <p>
                                    Il supporto post-consegna è disciplinato da accordi specifici che possono includere:
                                </p>
                                <ul>
                                    <li>Assistenza online e telefonica</li>
                                    <li>Assistenza on-site presso il cliente</li>
                                    <li>Pacchetti di assistenza scalabili</li>
                                    <li>Contratti di manutenzione programmata</li>
                                </ul>

                                <h2>10. Riservatezza</h2>
                                <p>
                                    BearSoftware si impegna a mantenere la massima riservatezza 
                                    sui dati e informazioni dei clienti, secondo quanto previsto 
                                    dalla normativa sulla privacy e da eventuali accordi di non divulgazione.
                                </p>

                                <h2>11. Modifiche dei Termini</h2>
                                <p>
                                    BearSoftware si riserva il diritto di modificare questi termini 
                                    in qualsiasi momento. Le modifiche saranno pubblicate su questa 
                                    pagina e entreranno in vigore dalla data di pubblicazione.
                                </p>

                                <h2>12. Risoluzione delle Controversie</h2>
                                <p>
                                    Eventuali controversie saranno risolte secondo la legge italiana 
                                    e sottoposte alla giurisdizione del tribunale competente per territorio.
                                </p>

                                <h2>13. Protezione Anti-Spam</h2>
                                <p>
                                    I moduli di contatto vengono inviati tramite il servizio{' '}
                                    <a href="https://web3forms.com" target="_blank" rel="noopener noreferrer">
                                        Web3Forms
                                    </a>{' '}
                                    che include protezione integrata contro spam e abusi automatizzati.
                                    Si applicano la{' '}
                                    <a href="https://web3forms.com/privacy" target="_blank" rel="noopener noreferrer">
                                        Privacy Policy
                                    </a>{' '}
                                    e i{' '}
                                    <a href="https://web3forms.com/terms" target="_blank" rel="noopener noreferrer">
                                        Termini di Servizio
                                    </a>{' '}
                                    di Web3Forms.
                                </p>

                                <h2>14. Contatti</h2>
                                <p>
                                    Per qualsiasi chiarimento sui presenti termini di servizio, 
                                    è possibile contattare BearSoftware all'indirizzo: info@bearsoftware.it
                                </p>

                                <h2>15. Validità</h2>
                                <p>
                                    Nel caso in cui una o più clausole di questi termini risultassero 
                                    invalide o inapplicabili, ciò non comprometterà la validità 
                                    delle rimanenti clausole.
                                </p>

                                <p className="text-muted mt-4">
                                    <small>Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</small>
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default TermsOfService;